import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { CAPTCHA } from 'constants/featureFlagging';
import { CaptchaBrandingInfo } from 'components/captchaBrandingInfo/CaptchaBrandingInfo';

function withRecaptcha(WrappedComponent) {
    class BaseWithRecaptcha extends PureComponent {
        isCaptchaActivated = () => this.props.flags.get(CAPTCHA);

        componentDidMount = () => {
            if (this.isCaptchaActivated()) this.loadRecaptcha();
        };

        componentWillUnmount = () => {
            const script = document.getElementById('reCaptchaScript');
            if (script) script.remove();
            const recaptchaBadge = document.getElementsByClassName('grecaptcha-badge');
            if (recaptchaBadge.length) recaptchaBadge[0].remove();
        };

        loadRecaptcha = () => {
            if (window.grecaptcha) {
                return;
            }
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${__GOOGLE_RECAPTCHA_SITEKEY__}`;
            script.id = 'reCaptchaScript';
            script.type = 'text/javascript';
            const tags = document.getElementsByTagName('script')[0];
            tags.parentNode.insertBefore(script, tags);
        };

        readyRecaptchaToken = callback => {
            if (!window.recaptcha && this.isCaptchaActivated()) {
                this.loadRecaptcha();
            }
            if (this.isCaptchaActivated()) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(__GOOGLE_RECAPTCHA_SITEKEY__, { action: 'submit' }).then(token => {
                        callback(token);
                    });
                });
            } else {
                callback();
            }
        };

        renderReCaptchaTermsAndConditions = () => {
            return <CaptchaBrandingInfo active={this.isCaptchaActivated()} text={'validation-captcha'} />;
        };

        render = () => {
            return (
                <WrappedComponent
                    {...this.props}
                    readyRecaptchaToken={this.readyRecaptchaToken}
                    isReCaptchaActive={this.isCaptchaActivated()}
                    renderReCaptchaTermsAndConditions={this.renderReCaptchaTermsAndConditions}
                />
            );
        };
    }

    return connect(state => ({
        flags: state.featureFlagging.get('data'),
    }))(BaseWithRecaptcha);
}

export default withRecaptcha;
